import React, { useState, useEffect } from "react";
import Loader from "../../components/styled-components/loader/loader";
import swal from "sweetalert";
import DEATH_API from "../../apis/death.api";
import { Select, Icon, message } from "antd";
import axios from "axios";
import { RewardsYearly } from "./RewardsYearly";
import ROUTES from "../../config/routes";
const { Option } = Select;

export const Rewards = () => {
  //   const [formData, setFormData] = useState(null);
  const [formData, setFormData] = useState({
    emails: [],
    nonEmails: [],
    message:
      "I have been using Asset Planet for 30 Days and it has changed my life! I believe you would get tremendous value from this software. Use this code for 50% off!",
  });
  const [clientContacts, setClientContacts] = useState([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);
  const [emailInput, setEmailInput] = useState("");
  function isValidEmail(email) {
    return /\S+@\S+\.\S+/.test(email);
  }
  const handlechange = (name, value) => {
    setFormData({
      ...formData,
      [name]: value,
    });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    console.log("Submit...", formData);
    const payload = {
      emails: [...formData.emails, ...formData.nonEmails],
      message: formData.message,
    };
    console.log("payload", payload);
    try {
      setLoading(true);
      const userToken = localStorage.getItem("userLoginToken");
      const baseUrl = `${ROUTES.BASE_URL}/dashboard-service`;
      const response = await axios.post(
        `${baseUrl}/email/for/invite`,
        payload,
        {
          headers: {
            Authorization: `Bearer ${userToken}`,
          },
        }
      );
      console.log("response", response);
      if (response && response.data && response.data.status === 200) {
        swal("Success", response.data.message, "success");
      }
      if (response && response.data && response.data.status === 400) {
        swal("Success", response.data.message, "success");
      }
      setLoading(false);
    } catch (error) {
      setLoading(false);
      if (error && error.response && error.response.data) {
        swal("Error", error.response.data.message, "error");
      }
      console.error("Error fetching user data:", error);
    }
  };
  const getContactsModule = async () => {
    try {
      setLoading(true);
      setClientContacts([]);
      let apiResponse = await DEATH_API.getClientContacts();
      console.log("apiResponse", apiResponse);
      if (apiResponse && apiResponse.data) {
        const apiData = apiResponse.data.map((item, index) => {
          let fullName = null;

          if (item.name && item.name.trim() !== "") {
            fullName = item.name.trim();
          } else {
            if (
              item.firstName &&
              item.firstName.trim() !== "" &&
              item.lastName &&
              item.lastName.trim() !== ""
            ) {
              fullName = item.firstName.trim() + " " + item.lastName.trim();
            }
          }

          // Add key with index + 1 value
          const newItem = { ...item, name: fullName };
          return newItem;
        });
        const filteredApiData = apiData.filter(
          (item) => item.name !== null && item.name !== ""
        );
        const filteredApiDataWithKeys = filteredApiData.map((item, index) => ({
          ...item,
          key: index + 1,
        }));
        setClientContacts(filteredApiDataWithKeys);
      }

      setLoading(false);
    } catch (error) {
      console.log(error);
      setLoading(false);
    }
  };
  console.log("clientContacts", clientContacts);
  useEffect(() => {
    getContactsModule();
  }, []);
  const handleEmailAdd = (e) => {
    console.log("e", e, emailInput);
    if (e.key === "Enter") {
      e.preventDefault();
      if (isValidEmail(emailInput)) {
        const uniqueEmails = Array.from(
          new Set([...formData.nonEmails, emailInput])
        );
        handlechange("nonEmails", uniqueEmails);
        setEmailInput("");
      } else {
        setError("Email is invalid");
      }
    }
  };
  const getEmailsByNames = (names) => {
    return names
      .map((name) => {
        const contact =
          clientContacts &&
          clientContacts.find((contact) => contact.name === name);
        return contact ? contact.email : null;
      })
      .filter((email) => email !== null); // Filter out null values
  };
  const removeEmail = (emailToRemove) => {
    const updatedEmails =
      formData &&
      formData.nonEmails &&
      formData.nonEmails.filter((email) => email !== emailToRemove);
    handlechange("nonEmails", updatedEmails);
  };

  return (
    <div>
    <div style={{ display: "flex" }}>
      <div
        className="MainDashboard1"
        style={{
          background: "white",
          borderRadius: "8px",
          marginBottom: "2rem",
          width: "100%",
        }}
      >
        <div className="feedbackMainHeading">Rewards</div>
        <form onSubmit={handleSubmit}>
          <div style={{ width: "70%", marginTop: "1rem", marginLeft: "2rem" }}>
            <div style={{ marginTop: "8px" }}>
              <div className="fieldsLable">30-Day Invitation</div>
              <textarea
                className="inputFieldClass"
                style={{ width: "100%" }}
                placeholder="Message"
                rows={4}
                value={formData && formData.message}
                onChange={(e) => {
                  e.preventDefault();
                  handlechange(e.target.name, e.target.value);
                }}
                name="message"
              />
            </div>
            <div
              style={{
                display: "flex",
                justifyContent: "space-between",
                gap: "1rem",
              }}
            >
              <div style={{ marginTop: "8px", width: "45%" }}>
                <div className="fieldsLable">Contacts to Invite</div>

                <Select
                  showSearch
                  placeholder="-Select-"
                  mode="tags"
                  // value={groups && groups !== null && groups}
                  onChange={(value, id) => {
                    console.log("value", value, id);
                    const correspondingEmails = getEmailsByNames(value);
                    const uniqueEmails = Array.from(
                      new Set([...correspondingEmails])
                    );
                    handlechange("emails", uniqueEmails);
                    // handlechange("emails", value);
                    // setGroups(value);
                  }}
                  style={{ marginTop: "6px", marginBottom: "1rem" }}
                >
                  {clientContacts &&
                    clientContacts.map((item, index) => (
                      <Option key={index} value={item.name}>
                        {item.name}
                      </Option>
                    ))}
                </Select>
              </div>
              <div style={{ marginTop: "8px", width: "45%" }}>
                <div className="fieldsLable">Invite Non-Contact </div>
                <input
                  className="inputFieldClass"
                  style={{ width: "100%" }}
                  placeholder="Email"
                  type="email"
                  value={emailInput}
                  onKeyPress={handleEmailAdd}
                  onChange={(e) => {
                    e.preventDefault();
                    e.persist();
                    if (!isValidEmail(e.target.value)) {
                      if (e.target.value === "") {
                        setError(null);
                      } else {
                        setError("Email is invalid");
                      }
                    } else {
                      setError(null);
                    }
                    setEmailInput(e.target.value);
                    // handlechange(e.target.name, e.target.value);
                  }}
                  name="email"
                />
                {error && (
                  <span style={{ color: "red", fontSize: "12px" }}>
                    {error}
                  </span>
                )}
              </div>
            </div>
            <div
              style={{
                marginBottom: "1rem",
                marginTop: "1rem",
                display: "flex",
                gap: "1rem",
              }}
            >
              {formData &&
                formData.nonEmails &&
                formData.nonEmails.map((email, index) => (
                  <div
                    key={index}
                    className="savebutton"
                    style={{ width: "fit-content" }}
                  >
                    {email}
                    <span
                      className="custom-footer-text"
                      onClick={() => {
                        removeEmail(email);
                      }}
                    >
                      <Icon
                        type="close-circle"
                        style={{
                          marginBottom: "3px",
                          marginLeft: "8px",
                          fontWeight: "800",
                          fontSize: "18px",
                        }}
                      />{" "}
                    </span>
                  </div>
                ))}
            </div>
            <button
              className="feedbackButton"
              type="submit"
              disabled={
                formData && (formData.emails.length>0 || formData.nonEmails.length>0)
                  ? false
                  : true
              }
              style={{
                opacity:
                  formData && (formData.emails.length>0 || formData.nonEmails.length>0)
                    ? "1"
                    : "0.5",
                cursor:
                  formData && (formData.emails.length>0 || formData.nonEmails.length>0)
                    ? "pointer"
                    : "not-allowed",
              }}
              // onClick={handleSubmit}
            >
              Send Invitation
            </button>
          </div>
        </form>
        <RewardsYearly contacts={clientContacts && clientContacts}/>
      </div>
      {/* <div className="notificationMain">
        <DashboardNotificationSection />
        </div> */}
      <Loader isLoading={loading} />
    </div>
    
    </div>
  );
};
